module.exports = __webpack_public_path__ + "img/11.414b261.png";